import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ExperimentWinningCriteriaDefinition } from 'modules/graphql';
import { WinningCriteriaCellStyle, CaptionText } from './Styled';

export const WinningCriteriaCell = ({ name, type }: ExperimentWinningCriteriaDefinition) => {
  const { t } = useExperimentsTranslations();
  return (
    <WinningCriteriaCellStyle>
      <div>{name}</div>
      <CaptionText>
        {t<string, Record<string, string>>('table.events', { returnObjects: true })[type]}
      </CaptionText>
    </WinningCriteriaCellStyle>
  );
};
